import React from 'react';
import { Leaf } from 'lucide-react';
export function BotanicalDivider() {
  return <div className="flex items-center justify-center py-8 opacity-40" data-id="element-207">
      <div className="h-px w-16 bg-[#4A5D3A]" data-id="element-208"></div>
      <Leaf className="mx-4 text-[#4A5D3A]" size={20} strokeWidth={1.5} data-id="element-209" />
      <div className="h-px w-16 bg-[#4A5D3A]" data-id="element-210"></div>
    </div>;
}